export function applyGeoJsonLayer(
  map: mapboxgl.Map,
  geojson: GeoJSON.FeatureCollection,
) {
  if (!map.getSource("areas")) {
    map.addSource("areas", {
      type: "geojson",
      data: geojson,
    });
  } else {
    (map.getSource("areas") as mapboxgl.GeoJSONSource).setData(geojson);
  }

  if (!map.getLayer("areas-fill")) {
    map.addLayer({
      id: "areas-fill",
      type: "fill",
      source: "areas",
      paint: {
        "fill-color": "#0000ff",
        "fill-opacity": 0.3,
      },
    });
  }

  if (!map.getLayer("areas-outline")) {
    map.addLayer({
      id: "areas-outline",
      type: "line",
      source: "areas",
      paint: {
        "line-color": "#FFFFFF",
        "line-width": 1,
      },
    });
  }
}
